import { createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex items-center gap-1.5"
};
const _hoisted_2 = { class: "relative inline-flex items-center" };
const _hoisted_3 = ["value", "onChange"];
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "relative inline-flex items-center" };
const _hoisted_6 = ["value", "onChange"];
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "-mx-2 mt-4 flex flex-col gap-y-4 sm:flex-row sm:gap-x-4 sm:gap-y-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["CalendarRoot"], _mergeProps({
        "data-slot": "calendar",
        class: $setup.cn('p-4', $setup.props.class)
    }, $setup.forwarded, { "weekday-format": $setup.weekdayFormat }), {
        default: _withCtx(({ grid, weekDays }) => [
            _createVNode($setup["CalendarHeader"], { class: "relative -mx-2.5 -mt-2.5 flex items-center justify-between px-px pb-2" }, {
                default: _withCtx(() => [
                    _createVNode($setup["CalendarPrev"], {
                        class: _normalizeClass($setup.cn('inline-flex size-8 items-center justify-center rounded-md bg-transparent transition-colors hover:bg-accent hover:text-accent-foreground disabled:pointer-events-none disabled:opacity-50', $setup.navigationBorderClass))
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["ChevronLeft"], { class: "size-5" })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createCommentVNode(" Shows month and year dropdown in the date picker "),
                    ($props.showMonthYearDropdowns)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("select", {
                                    value: grid[0]?.value?.month,
                                    class: "h-9 appearance-none rounded-md border border-input bg-background pl-3 pr-8 text-sm shadow-xs transition-colors focus:outline-none focus:ring-1 focus:ring-ring cursor-pointer",
                                    onChange: (e) => $setup.onMonthChange(grid, e)
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.monthNames, (name, i) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: i,
                                            value: i + 1
                                        }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_4));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
                                _createVNode($setup["ChevronDown"], { class: "pointer-events-none absolute right-2 size-3.5 text-muted-foreground" })
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("select", {
                                    value: grid[0]?.value?.year,
                                    class: "h-9 appearance-none rounded-md border border-input bg-background pl-3 pr-8 text-sm shadow-xs transition-colors focus:outline-none focus:ring-1 focus:ring-ring cursor-pointer",
                                    onChange: (e) => $setup.onYearChange(grid, e)
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.yearRange, (year) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: year,
                                            value: year
                                        }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_7));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                                _createVNode($setup["ChevronDown"], { class: "pointer-events-none absolute right-2 size-3.5 text-muted-foreground" })
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" Default variant: text heading "),
                            _createVNode($setup["CalendarHeading"], { class: "text-sm font-medium" })
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                    _createVNode($setup["CalendarNext"], {
                        class: _normalizeClass($setup.cn('inline-flex size-8 items-center justify-center rounded-md bg-transparent transition-colors hover:bg-accent hover:text-accent-foreground disabled:pointer-events-none disabled:opacity-50', $setup.navigationBorderClass))
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["ChevronRight"], { class: "size-5" })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"])
                ]),
                _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grid, (month) => {
                    return (_openBlock(), _createBlock($setup["CalendarGrid"], {
                        key: month.value.toString(),
                        class: "w-full border-collapse space-y-1"
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["CalendarGridHead"], null, {
                                default: _withCtx(() => [
                                    _createVNode($setup["CalendarGridRow"], { class: "flex w-full gap-1" }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                                                return (_openBlock(), _createBlock($setup["CalendarHeadCell"], {
                                                    key: day,
                                                    class: "flex-1 text-center text-[0.8rem] font-normal text-muted-foreground"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(day), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createVNode($setup["CalendarGridBody"], null, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.rows, (weekDates, index) => {
                                        return (_openBlock(), _createBlock($setup["CalendarGridRow"], {
                                            key: `weekDate-${index}`,
                                            class: "mt-2 flex w-full gap-1"
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDates, (weekDate) => {
                                                    return (_openBlock(), _createBlock($setup["CalendarCell"], {
                                                        key: weekDate.toString(),
                                                        date: weekDate,
                                                        class: "flex flex-1 items-center justify-center p-0 text-center text-sm focus-within:relative focus-within:z-20"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode($setup["CalendarCellTrigger"], {
                                                                day: weekDate,
                                                                month: month.value,
                                                                class: _normalizeClass($setup.cn('inline-flex size-10 items-center justify-center rounded-md p-0 text-sm font-normal transition-colors', $setup.isCompact && 'size-8', 'hover:bg-accent hover:text-accent-foreground', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring', 'disabled:pointer-events-none disabled:opacity-50', 'data-outside-view:text-muted-foreground data-outside-view:opacity-30', 'data-today:font-semibold', 'data-selected:bg-accent data-selected:text-accent-foreground', 'data-selected:hover:bg-accent data-selected:hover:text-accent-foreground', 'data-unavailable:pointer-events-none data-unavailable:line-through data-unavailable:opacity-30', $setup.isCompact && 'data-selected:bg-en-red-500 data-selected:text-white data-selected:hover:bg-en-red-500 data-selected:hover:text-white data-unavailable:no-underline'))
                                                            }, null, 8 /* PROPS */, ["day", "month", "class"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["date"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */));
                }), 128 /* KEYED_FRAGMENT */))
            ])
        ]),
        _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["class", "weekday-format"]));
}
